import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { useI18n } from 'i18n';
import { ITepEntryPass } from 'types/tep';
import { ISelectOption } from 'types/select';
import Loader from 'core/react/general/Loader';
import TagPicker from 'core/react/general/form/TagPicker';
import { tepHistoryReportSelector } from 'core/redux/selectors/reports';

interface IEntryPassesPickerProps {
  disabled: boolean;
  value?: string[];
  onChange: (value: string[]) => void;
}

export const EntryPassesPicker: FC<IEntryPassesPickerProps> = (props) => {
  const { disabled, value, onChange } = props;

  const { entryPasses, parameters } = useSelector(tepHistoryReportSelector);

  const { f, fc } = useI18n();
  let content = null;

  const formatEventTypes = ({ device }: ITepEntryPass) => ({
    value: device.uri,
    label: fc({ prefix: 'device-event', id: device.name }),
  });

  if (entryPasses) {
    const items = entryPasses.map(formatEventTypes);

    const compare = () => (a: ISelectOption<string>, b: ISelectOption<string>) => {
      if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
      if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
      return 0;
    };

    content = (
      <TagPicker
        data={items}
        value={value || parameters?.entryPasses || []}
        onChange={onChange}
        placeholder={f('search')}
        label={f('Select TEP')}
        sort={compare}
        disabled={disabled}
        style={{ minHeight: '37px' }}
      />
    );
  } else content = <Loader />;

  return <div className="event-type-picker">{content}</div>;
};
